export * from "ce/pages/Editor/IDE/EditorPane/Query/utils";

import {
  getQueryEntityItemUrl as CE_getQueryEntityItemUrl,
  getQueryUrl as CE_getQueryAddUrl,
} from "ce/pages/Editor/IDE/EditorPane/Query/utils";
import type { EntityItem } from "ee/entities/IDE/constants";
import { moduleInstanceEditorURL } from "ee/RouteBuilder";
import { MODULE_TYPE } from "ee/constants/ModuleConstants";
import type { FocusEntityInfo } from "navigation/FocusEntity";

export const getQueryEntityItemUrl = (
  item: EntityItem,
  basePageId: string,
): string => {
  if (item.isModuleInstance) {
    return moduleInstanceEditorURL({
      basePageId,
      moduleType: MODULE_TYPE.QUERY,
      moduleInstanceId: item.key,
    });
  }

  return CE_getQueryEntityItemUrl(item, basePageId);
};

export const getQueryUrl = (
  item: FocusEntityInfo,
  add: boolean = true,
): string => {
  if (item.params.moduleInstanceId) {
    return moduleInstanceEditorURL({
      basePageId: item.params.basePageId,
      moduleType: MODULE_TYPE.QUERY,
      moduleInstanceId: item.params.moduleInstanceId,
      add,
    });
  }

  return CE_getQueryAddUrl(item, add);
};
